export default "__VITE_ASSET__D02uQKCa__"